module.exports = __webpack_public_path__ + "img/diario-financiero.6b5fa56a.png";